// import React, { useEffect, useRef, useState } from "react";
// import { hightlightsSlides } from "../constants";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";

// const VideoCarousel = () => {
//   const videoRef = useRef([]);
//   const videoSpanRef = useRef([]);
//   const videoDivRef = useRef([]);
//   const [video, setVideo] = useState({
//     isEnd: false,
//     startPlay: false,
//     videoId: 0,
//     isLastVideo: false,
//     isPlaying: false,
//   });

//   // load video state
//   const [loadedData, setLoadedData] = useState([]);
//   const { isEnd, startPlay, videoId, isLastVideo, isPlaying } = video;

//   useGSAP(() => {
//     gsap.to("#video", {
//       scrollTrigger: {
//         trigger: "#video",
//         toggleActions: "restart none none none",
//       },
//       onComplete: () => {
//         setVideo((prev) => ({ ...prev, startPlay: true, isPlaying: true }));
//       },
//     });
//   }, [isEnd, videoId]);
//   // onPlay use effect
//   useEffect(() => {
//     if (loadedData.length > 3) {
//       if (!isPlaying) {
//         videoRef.current[videoId].pause();
//       } else {
//         startPlay && videoRef.current[videoId].play();
//       }
//     }
//   }, [startPlay, videoId, isPlaying, loadedData]);
//   // handle loaded data
//   const handleLoadedMetaData = (i, e) => {
//     setLoadedData((prev) => [...prev, e]);
//   };
//   // on update useEffect
//   useEffect(() => {
//     const currentProgress = 0;
//     let span = videoSpanRef.current;
//     if (span[videoId]) {
//       let anim = gsap.to(span[videoId], {
//         onUpdate: () => {},
//         onComplete: () => {},
//       });
//     }
//   }, [videoId, startPlay]);

//   // handle process
//   const handleProcess = (type, i) => {
//     switch (type) {
//       case "video-end":
//         setVideo((prev) => ({ ...prev, isPlaying: true, videoId: i + 1 }));
//         break;
//       case "video-last":
//         setVideo((prev) => ({ ...prev, isLastVideo: true }));
//         break;
//       case "video-reset":
//         setVideo((prev) => ({
//           ...prev,
//           isLastVideo: false,
//           videoId: 0,
//         }));
//         break;
//       case "play":
//         setVideo((prev) => ({
//           ...prev,
//           isPlaying: !prev.isPlaying,
//         }));
//         break;
//       default:
//         return video;
//     }
//     return (
//       <>
//         <div className="flex items-center">
//           {hightlightsSlides.map((list, i) => (
//             <div key={list.id} id="slider" className="sm:pr-20 pr-10">
//               <div className="video-carousel_container">
//                 <div className="w-full h-full flex-center rounded-3xl overflow-hidden bg-black">
//                   <video
//                     id="video"
//                     playsInline={true}
//                     preload="auto"
//                     muted
//                     ref={(el) => (videoRef.current[i] = el)}
//                     onPlay={() => {
//                       setVideo((prevVideo) => ({
//                         ...prevVideo,
//                         isPlaying: true,
//                       }));
//                     }}
//                     onLoadedMetaData={(e) => handleLoadedMetaData(i, e)}
//                   >
//                     <source src={list.video} type="video/mp4" />
//                   </video>
//                 </div>
//                 {/* slide  */}
//                 <div className="absolute top-12 left-[5%] z-10">
//                   {list.textLists.map((text) => (
//                     <p key={text} className="md:text-2xl text-xl font-medium">
//                       {text}
//                     </p>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//         {/* play progress area */}
//         <div className="relative flex-center mt-10">
//           <div className="flex-center py-5 px-7 bg-gray-300 backdrop-blur rounded-full">
//             {videoRef.current.map((_, i) => (
//               <span
//                 key={i}
//                 ref={(el) => (videoDivRef.current[i] = el)}
//                 className="mx-2 w-3 h-3 bg-gray-200 rounded-full relative cursor-pointer"
//               >
//                 <span
//                   className="absolute h-full w-full rounded-full"
//                   ref={(el) => (videoSpanRef.current[i] = el)}
//                 />
//               </span>
//             ))}
//           </div>
//           {/* play and pause button */}
//           <button className="control-btn">
//             <img
//               src={isLastVideo ? replyImg : !isPlaying ? playImg : pauseImg}
//               alt={isLastVideo ? "Reply" : !isPlaying ? "Play" : "Pause"}
//               onClick={
//                 isLastVideo
//                   ? () => handleProcess("video-reset")
//                   : !isPlaying
//                   ? () => handleProcess("play")
//                   : () => handleProcess("pause")
//               }
//             />
//           </button>
//         </div>
//       </>
//     );
//   };
// };

// export default VideoCarousel;

import React, { useEffect, useRef, useState } from "react";
import { hightlightsSlides } from "../constants";
import gsap from "gsap";
import { pauseImg, playImg, replayImg } from "../utils";
import { useGSAP } from "@gsap/react";

const VideoCarousel = () => {
  const videoRef = useRef([]);
  const videoSpanRef = useRef([]);
  const videoDivRef = useRef([]);

  // video initial state
  const [video, setVideo] = useState({
    isEnd: false,
    startPlay: false,
    videoId: 0,
    isLastVideo: false,
    isPlaying: false,
  });

  // load video state
  const [loadedData, setLoadedData] = useState([]);
  // values destructure
  const { isEnd, startPlay, videoId, isLastVideo, isPlaying } = video;
  useGSAP(() => {
    // gsap for the slider and video changing
    gsap.to("#slider", {
      transform: `translateX(${-100 * videoId}%)`,
      duration: 2,
      ease: "power2.inOut",
    });

    // gsap for video
    gsap.to("#video", {
      scrollTrigger: {
        trigger: "#video",
        toggleActions: "restart none none none",
      },
      onComplete: () => {
        setVideo((prev) => ({
          ...prev,
          startPlay: true,
          isPlaying: true,
        }));
      },
    });
  }, [isEnd, videoId]);
  // useeffect for playing the video
  useEffect(() => {
    if (loadedData.length > 3) {
      if (!isPlaying) {
        videoRef.current[videoId].pause();
      } else {
        startPlay && videoRef.current[videoId].play();
      }
    }
  }, [startPlay, videoId, isPlaying, loadedData]);
  // handle loaded data
  const handleLoadedMetaData = (i, e) => {
    setLoadedData((prev) => [...prev, e]);
  };

  // use effect for update and complete
  useEffect(() => {
    let currentProgress = 0;
    let span = videoSpanRef.current;
    if (span[videoId]) {
      let anim = gsap.to(span[videoId], {
        onUpdate: () => {
          const progress = Math.ceil(anim.progress() * 100);
          if (progress !== currentProgress) {
            currentProgress = progress;
            gsap.to(videoDivRef.current[videoId], {
              width:
                window.innerWidth < 768
                  ? "10vw"
                  : window.innerWidth < 1200
                  ? "10vw"
                  : "4vw",
            });
            gsap.to(span[videoId], {
              width: `${currentProgress}%`,
              backgroundColor: "white",
            });
          }
        },
        onComplete: () => {
          if (isPlaying) {
            gsap.to(videoDivRef.current[videoId], {
              width: "12px",
            });

            gsap.to(span[videoId], {
              background: "#afafaf",
            });
          }
        },
      });
      if (videoId === 0) {
        anim.restart();
      }
      const animUpdate = () => {
        anim.progress(
          videoRef.current[videoId].currentTime /
            hightlightsSlides[videoId].videoDuration
        );
      };

      if (isPlaying) {
        gsap.ticker.add(animUpdate);
      } else {
        gsap.ticker.remove(animUpdate);
      }
    }
  }, [videoId, startPlay]);
  // handleprocess for onclick
  const handleProcess = (type, i) => {
    switch (type) {
      case "video-end":
        setVideo((prev) => ({ ...prev, isEnd: true, videoId: i + 1 }));
        break;
      case "video-last":
        setVideo((prev) => ({ ...prev, isLastVideo: true, videoId: 0 }));
        break;
      case "video-reset":
        setVideo((prev) => ({
          ...prev,
          isLastVideo: false,
          videoId: 0,
        }));
        break;
      case "play":
        setVideo((prev) => ({ ...prev, isPlaying: !prev.isPlaying }));
        break;
      case "pause":
        setVideo((prev) => ({ ...prev, isPlaying: !prev.isPlaying }));
        break;
      default:
        return video;
    }
  };

  return (
    <>
      {" "}
      <div className="flex items-center">
        {hightlightsSlides.map((list, i) => (
          <div key={list.id} id="slider" className="sm:pr-20 pr-10">
            <div className="video-carousel_container">
              <div className="w-full h-full flex-center rounded-3xl overflow-hidden bg-black">
                <video
                  id="video"
                  playsInline={true}
                  preload="auto"
                  muted
                  ref={(el) => (videoRef.current[i] = el)}
                  onPlay={() => {
                    setVideo((prevVideo) => ({
                      ...prevVideo,
                      isPlaying: true,
                    }));
                  }}
                  onLoadedMetadata={(e) => handleLoadedMetaData(i, e)}
                  onEnded={() =>
                    i !== 3
                      ? handleProcess("video-end", i)
                      : handleProcess("video-last")
                  }
                  className={`${
                    list.id === 2 && "translate-x-44"
                  } pointer-events-none`}
                >
                  <source src={list.video} type="video/mp4" />
                </video>
              </div>
              <div className="absolute top-12 left-[5%] z-10">
                {list.textLists.map((text) => (
                  <p key={text} className="md:text-2xl text-xl font-medium">
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* buttons for control */}
      <div className="relative flex-center mt-10">
        <div className="flex-center py-5 px-7 bg-gray-300 backdrop-blur rounded-full">
          {videoRef.current.map((_, i) => (
            <span
              key={i}
              ref={(el) => (videoDivRef.current[i] = el)}
              className="mx-2 w-3 h-3 bg-gray-200 rounded-full relative cursor-pointer"
            >
              <span
                className="absolute h-full w-full rounded-full"
                ref={(el) => (videoSpanRef.current[i] = el)}
              />
            </span>
          ))}
        </div>
        {/* play and pause button */}
        <button className="control-btn">
          <img
            src={isLastVideo ? replayImg : !isPlaying ? playImg : pauseImg}
            alt={isLastVideo ? "replay" : !isPlaying ? "play" : "pause"}
            onClick={
              isLastVideo
                ? () => handleProcess("video-reset")
                : !isPlaying
                ? () => handleProcess("play")
                : () => handleProcess("pause")
            }
          />
        </button>
      </div>
    </>
  );
};

export default VideoCarousel;
